import React, { useState } from "react";
import styles from "../../styles/components/basicemptwinForm.module.scss";
import Icons from "../../public/assets/svg";
import "react-datetime/css/react-datetime.css";
import Router from "next/router";
import DropDown from "../listWithoutcheck";
import { useDispatch, connect } from "react-redux";
import _get from "lodash/get";
import _ from "lodash";
import endpoint from "../../utility/endpoints.js";
import axios from "axios";
import CheckboxDropdown from "../listDropdown/indexemptwin.jsx";
import Loader from "../Loader"
import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions.js";
import { bindActionCreators } from "redux";
function index(props) {
  // to convert labels into camelcase
  //console.log(props.data,"savedState");
  const [auth, setAuth] = useState({});
  const [allGlobalFields, setAllGlobalFields] = useState([]);
  const [requiredFieldsArray, setRequiredFieldsArray] = useState([]);
  let initialStates = {};
  let dropDownsInitialStates = {};
  const [requiredFields, setRequiredFields] = React.useState([])
  React.useEffect(() => {
    setAuth(JSON.parse(localStorage.getItem("auth")).data);
    props.data.map((item) => {
      //console.log("jjjjjjj",item)
      if (item.field_label == "MCO") {
        item.value = "mco";
      }else {
        item.value = camelize(item.field_label);
      }
    });

    props.data.map((item) => {
      if (
        item.field_input_type == "Related Dropdown" &&
        item.field_related_dropdown.length > 0
      ) {
        let fieldOptions = [];
        item.field_dropdown_option_component.map((item) => {
          fieldOptions = [...fieldOptions, ...item.field_options];
        });
      }
    });


  
   let requiredFields = [];

    props.data.map((item) => {
      if (item.field_required == "1") {
        if (item.field_label == "Country") {
          initialStates[item.value] = [];
        } else {
          // initialStates[item.value] = "";
        }
      }
      if (
        item.field_input_type == "Dropdown" ||
        item.field_input_type == "Related Dropdown"
      ) {
        dropDownsInitialStates[item.value] = false;
      }
      if (item.field_required == "1") {
        
          requiredFields.push(item.value);
        
      }
    });
    setRequiredFieldsArray([...requiredFields]);
    setAllGlobalFields(props.data);
  }, []);

  function camelize(str) {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  }
  const [relatedDropdowns, setRelatedDropdowns] = React.useState(null);
  React.useEffect(() => {
    let relatedDropdownToSet = {};
    props.data.map((item) => {
      if (item.field_input_type == "Related Dropdown") {
        relatedDropdownToSet = {
          ...relatedDropdownToSet,
          [item.value]: { allValues: item.field_dropdown_option_component },
        };
      }
    });

    props.data.map((item) => {
      
      if (
        item.field_related_dropdown !== "" &&
        item.field_related_dropdown !== null &&
        item.field_related_dropdown !== undefined
      ) {
        if ( !_.isEmpty(props.savedState)) {
          //console.log(props.savedState.country, "countryy");
        //console.log("====>#1",relatedDropdownToSet["mco"])
        //console.log("====>#11",camelize(item.field_related_dropdown))
          
          if (
            relatedDropdownToSet[
              camelize(item.field_related_dropdown) == "mCO"
                ? "mco"
                : camelize(item.field_related_dropdown)
            ] !== undefined
          ) {
            //console.log(relatedDropdownToSet,"savedState");
            let nowValuesArr = relatedDropdownToSet[
              camelize(item.field_related_dropdown) == "mCO"
                ? "mco"
                : camelize(item.field_related_dropdown)
            ].allValues.filter(
              (innerItem) =>
              (camelize(item.field_related_dropdown)=="country")?props.savedState[item.value].includes(innerItem.field_title):
                innerItem.field_title == props.savedState[item.value]
            );

               //console.log("====>#2",props.savedState[item.value])
               //console.log("====>#3",nowValuesArr)

            if(nowValuesArr.length>0){
             var nowValues = []
             nowValuesArr.map((val)=>{
              nowValues.push(...val.field_options)
             })
            }
            //console.log("====>#4",nowValues)
            //console.log(nowValues,"relatedDropdownToSet");
            relatedDropdownToSet[
              camelize(item.field_related_dropdown) == "mCO"
                ? "mco"
                : camelize(item.field_related_dropdown)
            ].nowValues = nowValues;
          }
        }
      }
    });


    setRelatedDropdowns(relatedDropdownToSet);
  }, []);

  const [state, setState] = React.useState(initialStates);

  const [dropDownState, setDropdownState] = React.useState(
    dropDownsInitialStates
  );

  const [invalidFlag, setInvalidFlag] = React.useState(false);

  const dispatch = useDispatch();
 

  const handleDropDown = (item) => {
    setDropdownState({
      ...dropDownsInitialStates,
      [item]: !dropDownState[item],
    });
  };



  const gotDropDownValue = (value, dropdownParent, haveRelated , checkbox) => {
    //console.log("========>1",value)
    //console.log("========>2",dropdownParent)
    //console.log("========>3", haveRelated)
    //console.log("========>4", checkbox)
    if (value == "None") {
      if (dropdownParent == "country") {
        setState({ ...state, [dropdownParent]: [] });
      } else {
        let newState = state;
        delete newState[dropdownParent];
        setState({ ...newState });
      }
    }
     else {
      if (dropdownParent == "status") {
        //console.log(value, "valuessToBeAttatchedToForLIFE")
        
  
      } 

      
       else {
        if (haveRelated != null && haveRelated.length > 0) {
          let newState = state;
          delete newState[haveRelated];

         let myArr =  props.data.filter((item)=> item.value==haveRelated)
         
          if(myArr.length>0){
            if(myArr[0].field_related_dropdown){
              var emptyNowValues = camelize(myArr[0].field_related_dropdown)

            } 
          }

          props.data.map((item, index) => {
            if (item.value == haveRelated) {
              if (
                camelize(item.field_related_dropdown) != null &&
                camelize(item.field_related_dropdown).length > 0
              ) {
                //  let newerState = state
                if (camelize(item.field_related_dropdown) == "country") {
                  newState["country"] = [];
                  newState["mco"] = [];
                }
                else {
                  delete newState[camelize(item.field_related_dropdown)];
                }
              }
            }
          });

          setState(newState);

          //console.log(relatedDropdowns, "related Ka Khel");
          let selectedRelatedDropdown = relatedDropdowns;
            // selectedRelatedDropdown[haveRelated].nowValues =
            // selectedRelatedDropdown[haveRelated].allValues.filter(
            //   (item) => item.field_title == value
            // )[0].field_options;
          selectedRelatedDropdown[haveRelated].nowValues =""
          if(Array.isArray(value)){
            let arr=[] 
            selectedRelatedDropdown[haveRelated].allValues.filter(
              (item) => {
                return value.includes(item.field_title)
                //  item.field_title == value
              }
              ).map((va,index)=>arr.push(...va.field_options));
            selectedRelatedDropdown[haveRelated].nowValues=arr
          }else{
            selectedRelatedDropdown[haveRelated].nowValues=selectedRelatedDropdown[haveRelated].allValues.filter((item)=>item.field_title==value)[0].field_options
          }

            if(emptyNowValues){
              delete selectedRelatedDropdown[emptyNowValues].nowValues
             }

          setRelatedDropdowns({ ...selectedRelatedDropdown });
        }

        if (dropdownParent == "country") {
          let repeatedFlag = false;
          // alert(value+"==="+JSON.stringify(state[dropdownParent]))
          for (let i in state[dropdownParent]) {
            if (state[dropdownParent][i] == value) {
              repeatedFlag = true;
              break;
            }
          }
          if (!repeatedFlag) {
            // console.log("state[dropdownParent]",state[dropdownParent])
            setState({
              ...state,
              [dropdownParent]: [...state[dropdownParent], value],
            });
          }
          // setState({ ...state, [dropdownParent]: [value] });
          
        }
  
        else if (dropdownParent == "mco") {
          let repeatedFlag = false;
          for (let i in state[dropdownParent]) {
            if(Array.isArray(value)){
              if (state[dropdownParent][i] == value[value.length-1]) {
                repeatedFlag = true;
                break;
              }
            }else{
              if (state[dropdownParent][i] == value ) {
                repeatedFlag = true;
                break;
              }
            }
          }
          if (!repeatedFlag) {
            if(Array.isArray(value)){
              setState({
                ...state,
                [dropdownParent]: [...state[dropdownParent],value[value.length-1]],country: []
              });
            }else{
              setState({
                ...state,
                [dropdownParent]: [...state[dropdownParent], value],country: []
              });
            }
          }
          // setState({ ...state, [dropdownParent]: [value] });
          
        } else {
          setState({ ...state, [dropdownParent]: value });
        }
      }
    }
    if (!checkbox) {
      setDropdownState(dropDownsInitialStates);
    }
  };

React.useEffect(() => {
   //console.log(state.mco, "========>stateisAllineed")
}, [state])


  React.useEffect(() => {
    //console.log("props.savedState",props.savedState)
    if (props.savedState) {

      if (props.savedState.country) {
        if (typeof props.savedState.country == "string") {
          props.savedState.country = props.savedState.country.split(",");
          if (props.savedState.country[props.savedState.country.length-1] == ""){
            props.savedState.country.pop()
          }
        }
      }
      if (props.savedState.mco) {
        if (typeof props.savedState.mco == "string") {
          props.savedState.mco = props.savedState.mco.split(",");
          if (props.savedState.mco[props.savedState.mco.length-1] == ""){
            props.savedState.mco.pop()
          }
        }
      }
       
      setState({ ...state, ...props.savedState });
    }
  }, []);



  const removeCheckedValue = (option, dropdownParent,haveRelated) => {
    if(dropdownParent=="mco"){
      //console.log("removedChecked Value",option,dropdownParent,haveRelated)
      let changedCheckBoxAr =  state[dropdownParent].filter((item) => item != option)
      let selectedRelatedDropdown = relatedDropdowns;
      let arr=[] 
      selectedRelatedDropdown[haveRelated].allValues.filter(
        (item) => {
          return changedCheckBoxAr.includes(item.field_title)
          //  item.field_title == value
        }
        ).map((va,index)=>arr.push(...va.field_options));
      selectedRelatedDropdown[haveRelated].nowValues=arr
      setRelatedDropdowns({ ...selectedRelatedDropdown });

      setState({
        ...state,
        [dropdownParent] : [...changedCheckBoxAr],country:[]
      })
    }else{
      let changedCheckBoxAr =  state[dropdownParent].filter((item) => item != option)
      setState({
        ...state,
        [dropdownParent] : [...changedCheckBoxAr]
      })
      //console.log("removedChecked Value 1",changedCheckBoxAr)
    }
    }



  React.useEffect(() => {
    //console.log("========>state",state)

     const leadplatform=state.leadPlatform;
     const area=state.area;
     const subarea=state.subArea;
     const cluser=state.cluster;
     const mco=state.mco;
     const country=state.country;
    //console.log("leadplatform" , leadplatform);
    props.pass_GetData(state)


  }, [state])

  React.useEffect(() => {
    //console.log("state get form value basic form-----", state);
   //console.log(props.getFormValues, "getFormValues")
     if (props.getFormValues) {
     
       let moveAhead = true;
       //console.log("required Fields", requiredFieldsArray);
 
       for (let i in requiredFieldsArray) {
        
         if (
           state[requiredFieldsArray[i]] == "" ||
           state[requiredFieldsArray[i]] == false ||
           state[requiredFieldsArray[i]] === undefined ||
           state[requiredFieldsArray[i]] == undefined||
           state[requiredFieldsArray[i]] == "undefined"||
           state[requiredFieldsArray[i]] == null
         ) {
           //console.log(state[requiredFieldsArray[i]], "let's see")
         
           moveAhead = false;
           break;
         }
       }
       if (moveAhead == true) {
        
         //console.log("sendfrom ----" ,state)
        
         props.sendFormValues(state);
         
         setInvalidFlag(false);
       } else {
         setInvalidFlag(true);
       }
       if (props.setGetFormValues) {
         props.setGetFormValues(false);
       }
     }
   }, [props.getFormValues]);

  return (
    
    <>
          {allGlobalFields.map((item, index) => {
             if (
              item.field_input_type == "Dropdown" ||
              item.field_input_type == "Related Dropdown"
            ) {
              

              return (
                <div className="col-lg-6 col-md-6 col-12">
                <div className={styles.formGroup}>
                  <div>
                    <label className={styles.mainLabel}>
                      
                        {item.field_form_field_title}
                        {item.field_required == "1" ? <sup className={styles.mandatoryField}>*</sup> : null}
                     
                      {/* error message */}
                      {invalidFlag ? (
                        (state[item.value] == "" ||
                          
                          state[item.value] === undefined ||
                          state[item.value] == undefined ||
                          state[item.value] == "undefined" ||
                          state[item.value] == null) &&
                        item.field_required == "1" ? (
                          <span className={styles.errorMessage}>
                            {item.field_message_ip_error_message}
                          </span>
                        ) : null
                      ) : null}
                    </label>
                    <p className={`${styles.input} ${
                        invalidFlag
                          ? (state[item.value] == "" ||
                             
                              state[item.value] === undefined ||
                              state[item.value] == undefined ||
                              state[item.value] == "undefined" ||
                              state[item.value] == null) &&
                            item.field_required == "1"
                            ? styles.errorBorder
                            : null
                          : null
                      }`}
                      disabled={props.formType == "editBot"}
                      onClick={() => {
			 ((props.formType == "editBot") && (item.field_label == "Landscape"))?void(0): handleDropDown(item.value);

		       }}
                    >
                      <span className={styles.left}>
                        {state[item.value] == null ||
                        state[item.value] == "undefined" ||
                        state[item.value] === "" ||
                        state[item.value] === undefined
                        
                          ? item.field_input : 
                          (item.field_label == "Country" ? ((state.country !=undefined && state.country != null) ? ((state.country.length == 0) ? item.field_input : `${state.country.length} items selected`): item.field_input)
                          :item.field_label == "MCO" ? ((state.mco !=undefined && state.mco != null) ? ((state.mco.length == 0) ? item.field_input : `${state.mco.length} items selected`): item.field_input): state[item.value])}
                      </span>
                      {auth.userType != "supportStatus" ? item.field_label != "Support Status" ?
                      <span className={styles.right}>
                        <Icons name="chevron" className={styles.chevron} />
                      </span> :null:
                      <span className={styles.right}>
                      <Icons name="chevron" className={styles.chevron} />
                    </span>}
                    </p>
                    {dropDownState[item.value] == true ? (
                      item.field_label == "Country" ? (
                        <CheckboxDropdown
                          values={
                            item.field_input_type == "Related Dropdown"
                              ? relatedDropdowns[item.value].nowValues !=
                                undefined
                                ? [
                                    // "None",
                                    ...relatedDropdowns[item.value].nowValues,
                                  ]
                                : ["No parent Selected"]
                              : [
                                  // "None",
                                  ...item.field_options,
                                ]
                          }
                          removeCheckedValue={removeCheckedValue}
                          presentState={state.country}
                          getDropdownValue={gotDropDownValue}
                          haveRelated={
                            item.field_related_dropdown == "MCO"
                              ? "mco"
                              : camelize(item.field_related_dropdown)
                          }
                          dropdownParent={item.value}
                        />
                      ) 
                      :item.field_label == "MCO" ? (
                      <CheckboxDropdown
                        values={
                          item.field_input_type == "Related Dropdown"
                            ? relatedDropdowns[item.value].nowValues !=
                              undefined
                              ? [
                                  // "None",
                                  ...relatedDropdowns[item.value].nowValues,
                                ]
                              : ["No parent Selected"]
                            : [
                                // "None",
                                ...item.field_options,
                              ]
                        }
                        removeCheckedValue={removeCheckedValue}
                        presentState={state.mco}
                        getDropdownValue={gotDropDownValue}
                        haveRelated={camelize(item.field_related_dropdown)}
                        dropdownParent={item.value}
                      />)
                       : (
                        <DropDown
                          dropdownParent={item.value}
                          values={
                            item.field_input_type == "Related Dropdown"
                              ? relatedDropdowns[item.value].nowValues !=
                                undefined
                                ? [
                                    // "None",
                                    ...relatedDropdowns[item.value].nowValues,
                                  ]
                                : ["No parent Selected"]
                              : [
                                  // "None",
                                  ...item.field_options,
                                ]
                          }
                          getDropdownValue={gotDropDownValue}
                          // haveRelated={"mco"}
                          haveRelated={
                            item.field_related_dropdown == "MCO"
                              ? "mco"
                              : camelize(item.field_related_dropdown)
                          }
                          closeAllDropdowns={() => {
                            setDropdownState(dropDownsInitialStates);
                          }}
                        />
                      )
                    ) : null}
                   
                  
                </div>
                </div>
                </div>
                
              );
            }

          })}
        </>
  );
}


const mapStateToProps = (state) => ({
  currentBot: state.storeBot.currentBot,
});

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);



